import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaLaptopCode, FaUniversity, FaBriefcase, FaLightbulb } from 'react-icons/fa';
import '../Styles/About.css';

function About() {
    return (
        <section id="about" className="about-section">
            <Container>
                <Row className="justify-content-center">
                    <Col lg={10}>
                        <motion.h2
                            className="section-title"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            viewport={{ once: true }}
                        >
                            About Me
                        </motion.h2>
                        <motion.div
                            className="about-content"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                            viewport={{ once: true }}
                        >
                            <Row>
                                <Col md={6}>
                                    <div className="about-icon-container">
                                        <FaUniversity className="about-icon" />
                                    </div>
                                    <p className="about-text">
                                        I hold a Master's degree in Computer Science from the University of Colorado Boulder (GPA: 3.97/4.00), completed in May 2025. My academic foundation was built at Amrita University, India, where I earned my Bachelor's degree in Computer Science (GPA: 8.97/10.00).
                                    </p>
                                </Col>
                                <Col md={6}>
                                    <div className="about-icon-container">
                                        <FaBriefcase className="about-icon" />
                                    </div>
                                    <p className="about-text">
                                        Most recently, I worked as a Software Engineer at Credible Data, building AI agent systems with LangGraph and RAG. Previously, I worked as an SDE at the University of Colorado Boulder, an SDE Intern at Karsun Solutions, and a Software Engineer at SLB, spanning AI Engineering, backend development, cloud infrastructure, and data engineering.
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="about-icon-container">
                                        <FaLaptopCode className="about-icon" />
                                    </div>
                                    <p className="about-text">
                                        My technical expertise spans Python, Java, TypeScript, and frameworks like FastAPI, Flask, and Spring Boot. I specialize in AI/ML systems (LangGraph, RAG, LLMs), cloud infrastructure (GCP, AWS, Azure, Terraform), observability (OpenTelemetry, Grafana), and distributed systems with microservices architecture.
                                    </p>
                                </Col>
                                <Col md={6}>
                                    <div className="about-icon-container">
                                        <FaLightbulb className="about-icon" />
                                    </div>
                                    <p className="about-text">
                                        Outside of my professional life, I am passionate about continuous learning and innovation. I enjoy strength training, watching anime, and spending quality time with my family. These activities help me maintain a balanced and inspired life.
                                    </p>
                                </Col>
                            </Row>
                        </motion.div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default About;
